module.exports = "/static/media/icon-note-pinned.686027ab.svg";